export default "__VITE_ASSET__BRblyp4A__"